import { useParams, Link, Navigate } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import StickyEmergencyBar from "@/components/support/StickyEmergencyBar";
import { KB_ARTICLES } from "@/lib/supportContent";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const SupportKBArticle = () => {
  const { slug } = useParams();
  const article = KB_ARTICLES.find((a) => a.slug === slug);

  if (!article) return <Navigate to="/support" replace />;

  return (
    <>
      <SEO title={`${article.title} | Neil AI Support`} description={article.excerpt} />
      <div className="min-h-screen bg-[#05070A] text-white pb-32">
        <Navigation />
        <main className="max-w-3xl mx-auto px-4 pt-32 md:pt-40">
          <Button asChild variant="ghost" className="mb-6 text-muted-foreground hover:text-white">
            <Link to="/support"><ChevronLeft className="w-4 h-4 mr-1" />Back to Support</Link>
          </Button>
          <div className="text-xs uppercase tracking-wider text-primary mb-2">{article.category}</div>
          <h1 className="text-3xl md:text-4xl font-bold mb-8">{article.title}</h1>
          <article className="prose prose-invert max-w-none space-y-4 text-muted-foreground leading-relaxed">
            {article.body.split("\n\n").map((p, i) => (
              <p key={i}>{p.split("\n").map((line, j) => (<span key={j}>{line}<br /></span>))}</p>
            ))}
          </article>
        </main>
        <Footer />
        <StickyEmergencyBar />
      </div>
    </>
  );
};

export default SupportKBArticle;
